import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	billingData: null,
	billingValid: false,
	billingTrigger: null,
	paymentType: 'recurring',
	paymentMethod: 'upi',
};

const checkoutSlice = createSlice({
	name: 'checkout',
	initialState,
	reducers: {
		setBillingData: (state, action) => {
			state.billingData = action.payload;
		},
		setBillingValid: (state, action) => {
			state.billingValid = action.payload;
		},
		setBillingTrigger: (state, action) => {
			state.billingTrigger = action.payload;
		},
		setPaymentType: (state, action) => {
			state.paymentType = action.payload;
		},
		setPaymentMethod: (state, action) => {
			state.paymentMethod = action.payload;
		},
		clearCheckout: (state) => {
			state.billingData = null;
			state.billingValid = false;
			state.billingTrigger = null;
			state.paymentType = 'recurring';
			state.paymentMethod = 'upi';
		},
	},
});

export const {
	setBillingData,
	setBillingValid,
	setBillingTrigger,
	setPaymentType,
	setPaymentMethod,
	clearCheckout,
} = checkoutSlice.actions;

export default checkoutSlice.reducer;
